module.exports = __webpack_public_path__ + "officialStatic/img/xg.037c78b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/xg.png
// module id = La6/
// module chunks = 0